/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *
 * @export
 */
export const WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus = typeof WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus[keyof typeof WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus];


export function WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatusFromJSON(json: any): WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus {
    return WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatusFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus {
    return json as WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus;
}

export function WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatusToJSON(value?: WebApiServicesDataTransferObjectsMemberServicePaymentFilterStatus | null): any {
    return value as any;
}
